import React, { useState, useEffect } from 'react';
import SVGSearch from '../../assets/svgs/search';
import AppDropdown from './AppDropdown';
import Notifications from './Notifications';
import icon from '../../assets/img/mobligo_new.png';
import MobligoLogo from '../../assets/img/mobligo_new.png';
import { useSelector } from 'react-redux/es/hooks/useSelector';
import SecondaryButton from '../../components/ui/SecondaryButton';
import { useNavigate } from 'react-router-dom';
import TopBarSlider from '../../components/ui/TopBarSlider';
import { tabs } from '../DashboardTabs';
const Topbar = (props) => {
  const navigate = useNavigate();
  const { activeTab } = props;
  const windowWidth = useSelector((state) => state.eventListenerSlice?.windowSize)?.width
  const handleGoHelp = () => {
    navigate('/dashboard/help');
  }
  return (
    <div className="w-[100%] min-h-[60px] h-[60px]">
      <div className=" px-[20px] bg-white h-full border-b-[1px] text-lg self-center flex items-center w-full justify-between">
        <div className='flex gap-[20px] items-center w-full'>
          <div className=' overflow-hidden shrink-0'>

            <img
              className="cursor-pointer  h-[50px]"
              src={MobligoLogo}
            />
          </div>
          <div className="  overflow-hidden relative flex items-center rounded-full gap-[10px]" >
            <TopBarSlider activePageId={activeTab.id}>
              {tabs.map((tab, index) => {
                const renderElement = tab.icon
                return (

                  <div className={`${activeTab?.id == index ? "bg-[#7059ef] text-white" : "bg-[#F8F8F8] text-[#1C274C]"} min-w-[175px] w-full text-center cursor-pointer rounded-md px-[9px] py-[7px] text-[15px] flex flex-row justify-center items-center gap-[10px]`} onClick={() => {
                    !tab.isDisabled && navigate(tab.pointTo)
                  }}

                    style={{ cursor: tab.isDisabled ? "not-allowed" : "pointer", opacity: tab.isDisabled ? "0.5" : "1" }}
                  >
                    {renderElement.component &&

                      <renderElement.component className={`${activeTab?.id == index ? "stroke-white " : "stroke-[#60646F]"} ${renderElement.classNames} w-5 h-5 !stroke-[12px]`}></renderElement.component>
                    }
                    {tab.title}
                  </div>
                )
              })}

            </TopBarSlider>

          </div>

          <div className="flex flex-row items-center gap-4 md:gap-[20px] justify-end shrink-0 ml-auto">


            {/* {windowWidth > 1024 && <div className='flex gap-[20px]'> <button onClick={handleGoHelp} className='flex text-[#8a92a6] justify-center w-[50px] h-[50px] min-w-[50px] min-h-[50px] items-center text-[20px] border-1 border-[#E3E8EF] rounded-[10px]'  >?</button></div>} */}
            <AppDropdown />
          </div>

        </div>
      </div>
    </div >
  );
};

export default Topbar;
